import { render, staticRenderFns } from "./ClientEmploymentDietyHandler.vue?vue&type=template&id=7ff41456&scoped=true&"
import script from "./ClientEmploymentDietyHandler.vue?vue&type=script&lang=js&"
export * from "./ClientEmploymentDietyHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff41456",
  null
  
)

export default component.exports